import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  lastWithIcon: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    height: 24,
    width: 24,
    marginLeft: 8,
    '& path': {
      fill: theme.color.greys[80],
    },
  },
}), { name: 'MultipleWordsTextWithArrow', index: StylesIndexInjections.UI_ATOMS });

